/* eslint-disable react/jsx-no-useless-fragment */
import React, { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { RenderIf } from 'components';
import PreloaderComponent from 'components/Preloader/Preloader.component';
import { ILoginWithTokenMiddleware } from './@types';
import useExternalToken from './hooks/useExternalToken';
import { IEUseExternalTokenMatchParams } from './hooks/useExternalToken/@types';

const LoginWithTokenMiddleware: FC<ILoginWithTokenMiddleware> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get(IEUseExternalTokenMatchParams.TOKEN);

  const [finish, setFinish] = useState(false);

  const { isFinished, isSuccess } = useExternalToken(token as string);

  useEffect(() => {
    if (!token) {
      setFinish(true);
    }
  }, [token]);

  useEffect(() => {
    if (isFinished) {
      if (isSuccess) {
        const newQueryParams = queryParams;
        newQueryParams.delete(IEUseExternalTokenMatchParams.TOKEN);
        navigate({
          search: newQueryParams.toString(),
        });
        // window.location.reload();
      }

      setTimeout(() => {
        setFinish(true);
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFinished, isSuccess]);

  return (
    <RenderIf condition={finish} alternative={<PreloaderComponent />}>
      <>{children}</>
    </RenderIf>
  );
};

export default LoginWithTokenMiddleware;